/**
 * The phone app's words for the address book (piece 35, *Contacts, sites and the
 * address book (batch CR5)*; decision 4410): what the phone says about the
 * two-step Add Contact, an employment's and an occupancy's edit, Add Site and the
 * import from the phone's own contacts that the web does not already say. Spread
 * into the one string lookup beside the earlier batches' words. A word the web
 * already says, such as the employment window's labels, the occupancy window's,
 * the Add Site window's or the vCard import's, is read from the web's own key and
 * is not repeated here.
 */
export const CRM_CONTACTS_STRINGS = {
  'mobile.contacts.answerFirst': 'Answer the question above first.',
  'mobile.contacts.pickCompanyFirst': 'Pick a company to go on.',
  'mobile.contacts.lookFirst': 'Type the name first. The phone looks for somebody already here before it adds anyone.',
  'mobile.contacts.addingTo': 'This job is added to {name}, who is already here. No second person is made.',
  'mobile.import.action': 'Import from Phone Contacts',
  'mobile.import.title': 'Import from Phone Contacts',
  'mobile.import.subtitle': 'Pick one contact. The phone sends it as a card for the web’s import, and nothing is saved until Import.',
  'mobile.import.carries': 'The name, company, title, phone numbers, email addresses and postal addresses are sent. A photo, a birthday, notes and web addresses stay on the phone.',
  'mobile.import.pick': 'Choose a Contact',
  'mobile.import.pickAnother': 'Choose Another Contact',
  'mobile.import.denied': 'The phone did not let BMS2 read your contacts. Allow Contacts for BMS2 in the phone’s Settings, then try again.',
  'mobile.import.empty': 'That contact has no person name to import. A company on its own is not imported as a person.',
} as const;
